"use server";

import { redirect } from "next/navigation";

import { adminTwoFactorEnforced } from "@/lib/auth/two-factor";
import { t } from "@/lib/i18n";
import { createClient } from "@/lib/supabase/server";
import { loginSchema } from "@/lib/validation/auth";

export interface LoginState {
  error?: string;
}

/** Alleen interne paden toestaan als vervolg-URL (geen open redirect). */
function safeNextPath(value: FormDataEntryValue | null): string {
  if (typeof value === "string" && value.startsWith("/") && !value.startsWith("//")) {
    return value;
  }
  return "/";
}

export async function login(
  _prevState: LoginState,
  formData: FormData,
): Promise<LoginState> {
  const parsed = loginSchema.safeParse({
    email: formData.get("email"),
    password: formData.get("password"),
  });
  if (!parsed.success) {
    return { error: parsed.error.issues[0].message };
  }

  const supabase = await createClient();
  const { error } = await supabase.auth.signInWithPassword(parsed.data);
  if (error) {
    return { error: t.auth.ongeldigeInlog };
  }

  const next = safeNextPath(formData.get("volgende"));

  // Heeft de gebruiker tweestapsverificatie ingesteld, dan is de code-stap
  // verplicht — tenzij 2FA lokaal is uitgezet (DISABLE_ADMIN_2FA).
  if (adminTwoFactorEnforced()) {
    const { data: aal } =
      await supabase.auth.mfa.getAuthenticatorAssuranceLevel();
    if (aal && aal.nextLevel === "aal2" && aal.currentLevel !== "aal2") {
      redirect(
        `/login/tweestapsverificatie?volgende=${encodeURIComponent(next)}`,
      );
    }
  }

  redirect(next);
}

export async function logout(): Promise<void> {
  const supabase = await createClient();
  await supabase.auth.signOut();
  redirect("/login");
}
